import React, { InputHTMLAttributes, forwardRef } from 'react';
import styles from '../css/customTextInput.module.scss';

interface CustomTextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: string;
  error?: string;
  fullParentWidth?: boolean;
}

const CustomTextInput = forwardRef<HTMLInputElement, CustomTextInputProps>(({ icon, error, className = '', fullParentWidth = false, ...rest }, ref) => {
  return (
    <div className={`${styles.inputWrapper} ${fullParentWidth ? styles.fullWidth : ''}`}>
      {icon && <img width={14} height={14} src={icon} alt="" className={styles.inputIcon} />}
      <input ref={ref} {...rest} type={rest.type ?? 'text'} className={`${styles.textInput} ${icon ? styles.withIcon : ''} ${error ? styles.hasError : ''} ${className}`} />
    </div>
  );
});

CustomTextInput.displayName = 'CustomTextInput';

export default CustomTextInput;
